import React from 'react';
import PropTypes from 'prop-types';

import AddOnIcon from '../../AddOnIcon/AddOnIcon';
import AppendixScoreBarSection from '../../AppendixScoreBarSection/AppendixScoreBarSection';
import ScoreBarTypes from '../../../constants/ScoreBarTypes';
import { AddOnDetailModal } from '../../AddOnDetailModal';
import { useAddOnModal } from '../../AddOnDetailModal/useModalState';

export const WorkSafelyScores = props => {
    const {
        section,
        style,
        scoreRange,
        initials,
        languageId,
        i18nParticipation
    } = props;

    const { handleOpen, ...addOnModalProps } = useAddOnModal();

    return (
        <div className={style.workSafely}>
            {section.scores.map((score, index) => {
                if (!score.ranges) {
                    return null;
                }

                return (
                    <div
                        key={`${section.handle}-${score.name}-${index}`}
                        className={style.workSafelySectionScoreBar}
                        data-score-index={index}
                        onClick={handleOpen}
                        data-cy={`workSafely singlescore ${score.handle} viewall`}
                    >
                        <AppendixScoreBarSection
                            scoreValue={score.score}
                            scoreMin={scoreRange.MIN}
                            scoreMax={scoreRange.MAX}
                            lowLabel={score.lowLabel}
                            highLabel={score.highLabel}
                            scoreName={score.name}
                            scoreBarType={ScoreBarTypes.GAUGE}
                            initials={initials}
                            levelRanges={score.ranges}
                            classes={{
                                low: style.lowLabel,
                                high: style.highLabel,
                                scoreBlock:
                  style.multipleRankingSectionScoreBar__scoreBlockResistance,
                                colors: {
                                    red: style.red,
                                    orange: style.orange,
                                    green: style.green
                                }
                            }}
                        />

                        <div className={style.workSafelySectionIcon}>
                            <AddOnIcon handle={`icon_addon_${score.handle}`} />
                            <p>{score.name}</p>
                        </div>
                    </div>
                );
            })}

            <AddOnDetailModal
                {...addOnModalProps}
                section={section}
                scoreRange={scoreRange}
                initials={initials}
                languageId={languageId}
                i18nParticipation={i18nParticipation}
            />
        </div>
    );
};

WorkSafelyScores.defaultProps = {
    section: { scores: [] }
};

WorkSafelyScores.propTypes = {
    section: PropTypes.object.isRequired,
    style: PropTypes.object.isRequired,
    scoreRange: PropTypes.object.isRequired,
    initials: PropTypes.string.isRequired,
    languageId: PropTypes.number,
    i18nParticipation: PropTypes.object.isRequired
};
